var Marionette = require('backbone.marionette');

var PersonForm = require('./person-form-view');
var Person = require('../../models/person-model');
var OkDialogModal = require('../common/ok-message-dialog-with-action');

var CommonUtils = require('../../utils/common-utils.js');
var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');

var SignupView = Marionette.View.extend({
    template: require('../../templates/persons/signup.html'),

    regions: {
        personForm: '#person-form',
        inform: '#inform'
    },

    ui: {
        signupBtn: '#perform-signup'
    },

    events: {
        'click @ui.signupBtn': 'performSignup'
    },

    childViewEvents: {
        'person:save:valid': 'savePersonBtnEnableOrDisable'
    },

    initialize: function () {
        _.bindAll(this, 'performSignup');
        this.model = new Person();
        this.model.view = this;
        this.model.on('invalid', this.onErrors);
        this.utils = new CommonUtils();
    },

    onErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        window.document.title = "Signup";
        this.personForm = new PersonForm({model: this.model, isEditMode: false, forSignup: true});
        this.showChildView('personForm', this.personForm);
    },

    performSignup: function () {
        var that = this;
        that.model.set(that.personForm.fillModel().toJSON());
        that.model.urlRoot = '/api/login/signin';
        that.model.set('id', undefined);
        that.utils.showSpinner();
        that.model.save(that.model.toJSON(), {
            success: function (response) {
                that.utils.hideSpinner();
                that.personForm.clearModel();
                that.informUser();
            },
            error: function (model, xhr, options) {
                that.utils.hideSpinner();
                var errorResp = JSON.parse(xhr.responseText);
                errorResp.message = errorResp.message.replace("Entity", "Person").replace("id", "login");
                notificationsChannel.request('show:notification', errorResp);
                that.personForm.validateAllRequiredFields();
            }
        });
    },

    savePersonBtnEnableOrDisable: function (data) {
        if (data.result)
            this.ui.signupBtn.removeAttr("disabled");
        else
            this.ui.signupBtn.attr("disabled", "true");
    },

    informUser: function() {
        var that = this;
        that.informWindow = new OkDialogModal({
            title: 'Information',
            message: "Confirmation link was send on email provided. Please click on the link to activate your account",
            action: function() {
                Backbone.history.navigate('/login', {trigger: true});
            }
        });

        that.showChildView('inform', that.informWindow);
        that.informWindow.show();
    }
})

module.exports = SignupView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/sign-up-view.js
// module id = 390
// module chunks = 0